import { useSelector } from 'react-redux'

import { RootState } from '../../core/store/root.reducer'
import { UseSelectLine } from '../model/line.model'
import {
  selectNewNumber,
  selectIsNewNumberLoading,
  selectNewNumberError,
  selectOperator,
  selectIsOperatorLoading,
  selectOperatorError,
} from '../store/line.selectors'

export default function useSelectLine(id: string): UseSelectLine {
  const newNumber = useSelector((state: RootState) => selectNewNumber(state, id))
  const isNewNumberLoading = useSelector((state: RootState) => selectIsNewNumberLoading(state, id))
  const newNumberError = useSelector((state: RootState) => selectNewNumberError(state, id))
  const operator = useSelector((state: RootState) => selectOperator(state, id))
  const isOperatorLoading = useSelector((state: RootState) => selectIsOperatorLoading(state, id))
  const operatorError = useSelector((state: RootState) => selectOperatorError(state, id))

  return {
    newNumber,
    isNewNumberLoading,
    newNumberError,
    operator,
    isOperatorLoading,
    operatorError,
  }
}
